import { httpClient } from '../http/httpClient'
import { UserRoleEnum } from '../usersService/user'

export interface SignInParams {
  email?: string
  cpf?: string
  password: string
}

interface SignInResponse {
  accessToken: string
  user: {
    _id: string
    name: string
    role: UserRoleEnum
  }
}

export async function signin(params: SignInParams) {
  const { data } = await httpClient.post<SignInResponse>('/auth/login', {
    ...params,
    plataform: 'WEB',
  })

  return data
}
